import React, { useRef } from "react";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import CardSelectable from "../../components/cards/CardSelectable";

const CreditCard = ({
  state,
  noData,
  clientData,
  onClickData,
  clientAddress,
  onClickAddress,
  handleInputChange,
  handleInputFocus,
  completed,
}) => {


  const inputRef = useRef(null);
  const handleFocusWithRef = () => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(0, 0);
    }
  };


  return (
    <div>
      <Cards
        cvc={state.cvc}
        name={state.name}
        number={state.card_number}
        expiry={state.expiry}
        focused={state.focus}
        locale={{ valid: "Valido até" }}
        placeholders={{ name: "SEU NOME AQUI" }}
      />
      {!completed && (
        <div className="row mt-5">
          <div className="col-xl-6 mb-3">
            <InputText
              type="text"
              value={state.name}
              maxLength={30}
              className="w-100"
              placeholder="Nome impresso no cartão"
              onFocus={() => handleInputFocus("name")}
              onChange={(e) => handleInputChange("name", e.target.value)}
            />
          </div>
          <div className="col-xl-6 mb-3">
            <InputMask
              mask="9999 9999 9999 999?9"
              value={state.card_number}
              className="w-100"
              placeholder="Número impresso no cartão"
              onFocus={() => handleInputFocus("card_number")}
              onChange={(e) => handleInputChange("card_number", e.target.value)}
            />
          </div>

          <div className="col-xl-6 mb-3">
            <InputMask
              mask="99/99"
              value={state.expiry}
              className="w-100"
              placeholder="Validade"
              onFocus={() => handleInputFocus("expiry")}
              onChange={(e) => handleInputChange("expiry", e.target.value)}
            />
          </div>

          <div className="col-xl-6 mb-3">
            <InputMask
              mask="999?9"
              value={state.cvc}
              className="w-100"
              placeholder="CVV"
              onFocus={() => handleInputFocus("cvc")}
              onChange={(e) => handleInputChange("cvc", e.target.value)}
            />
          </div>

          {!noData && (
            <div className="col-xl-6 mb-3">
              <CardSelectable
                title="Dados do titular *"
                data={clientData}
                onClick={onClickData}
              />
            </div>
          )}

          <div className={`${!noData ? "col-xl-6" : "col-xl-12"} mb-3`}>
            <CardSelectable
              title="Endereço do titular *"
              data={clientAddress}
              onClick={onClickAddress}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CreditCard;
